// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"vW-z","inlineTitle":"wW-z","sponsoredAdsWrapper":"xW-z","marketplaceRecosWrapper":"yW-z"};